import { useState, useCallback } from 'react';
import { Product, WheelProduct } from '../../../../types';
import { wheelsApi } from '../../../../services/api';
import toast from 'react-hot-toast';

export const useWheelProducts = () => {
  const [wheelProducts, setWheelProducts] = useState<WheelProduct[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadWheelProducts = useCallback(async (wheelId: number) => {
    try {
      setIsLoading(true);
      const response = await wheelsApi.getProducts(wheelId);
      setWheelProducts(
        response.products.map(product => ({
          ...product,
          odds_weight: product.odds_weight || product.weight
        }))
      );
    } catch (error: any) {
      toast.error('Erro ao carregar produtos da roda');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const addProduct = useCallback((product: Product, oddsWeight: number) => {
    setWheelProducts(prev => [...prev, { ...product, odds_weight: oddsWeight }]);
  }, []);

  const removeProduct = useCallback((productId: number) => {
    setWheelProducts(prev => prev.filter(p => p.id !== productId));
  }, []);

  const updateOddsWeight = useCallback((productId: number, oddsWeight: number) => {
    setWheelProducts(prev =>
      prev.map(p => (p.id === productId ? { ...p, odds_weight: oddsWeight } : p))
    );
  }, []);

  const saveProducts = useCallback(async (wheelId: number) => {
    try {
      await wheelsApi.addProducts(
        wheelId,
        wheelProducts.map(p => ({ product_id: p.id, odds_weight: p.odds_weight }))
      );
      toast.success('Produtos salvos na roda!');
      return true;
    } catch (error: any) {
      toast.error('Erro ao salvar produtos');
      return false;
    }
  }, [wheelProducts]);

  const resetProducts = useCallback(() => {
    setWheelProducts([]);
  }, []);

  return {
    wheelProducts,
    isLoading,
    loadWheelProducts,
    addProduct,
    removeProduct,
    updateOddsWeight,
    saveProducts,
    resetProducts
  };
};
